import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import VueElementLoading from 'vue-element-loading';
import { useAppStore } from '@/store/app.store';
import Message from '@/components/Message.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isLoading = computed(() => {
  const appStore = useAppStore();
  return appStore.isLoading;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      id: "account-aria-live",
      "aria-live": "assertive",
      class: "coh-style-screen-reader-only"
    }, null, -1)),
    _createVNode(_unref(VueElementLoading), {
      active: isLoading.value,
      "is-full-screen": true
    }, null, 8, ["active"]),
    _createVNode(Message),
    _createVNode(_component_router_view),
    _createVNode(ScrollToTop)
  ]))
}
}

})